<template>
  <div class="animated fadeIn">
    <b-card>
      <b-row class="mb-3">
        <b-col cols="8">
          <div class="h5 font-weight-bold">{{customer.full_name}}</div>
          <div style="font-size: 0.7rem;">
            <div v-if="project">Project #: P-{{padPid(project.pid)}}</div>
            <div v-if="submission">Submission #: SU-{{padPid(submission.pid)}}</div>
            <div v-if="sample">Sample #: {{padPid(sample.pid)}}</div>
          </div>
        </b-col>
        <b-col cols="4">
          <img src="img/brand/logo.jpg" style="width: 100%">
        </b-col>
      </b-row>
      <barcode :value="padPid(sample.pid)" width="2" height="50" class="text-center">
        Show this if the rendering fails.
      </barcode>
    </b-card>
  </div>
</template>

<script>
  import VueBarcode from 'vue-barcode';
  export default {
    name: "SampleCustomerLabel",
    components: {
      'barcode': VueBarcode
    },
    props: ["customer", "sample", "submission", "project"],
    data() {
      return {}
    },
    methods: {
      padPid (pid) {
        return pid.toString().padStart(6, '0');
      }
    },
    mounted() {
      if(!this.submission) {
        let submission = this.sample.getSubmission();
        if(submission && submission.id) {
          this.submission = submission;
          let project = this.submission.getProject();
          if(project && project.id) {
            this.project = project;
          }
        }
      }
    }
  }
</script>
